/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 03.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import {
    orderProperties,
    retrieveSchema,
    getDefaultRegistry,
    isSelect,
    optionsList,
    getUiOptions,
    getWidget
} from "react-jsonschema-form/lib/utils";

class ObjectField extends React.Component {
    static propTypes = {
        schema: PropTypes.object.isRequired,
        uiSchema: PropTypes.object,
        errorSchema: PropTypes.object,
        idSchema: PropTypes.object,
        onChange: PropTypes.func.isRequired,
        formData: PropTypes.object,
        required: PropTypes.bool,
        disabled: PropTypes.bool,
        readonly: PropTypes.bool,
        autofocus: PropTypes.bool,
        registry: PropTypes.shape({
            widgets: PropTypes.objectOf(
                PropTypes.oneOfType([PropTypes.func, PropTypes.object])
            ).isRequired,
            fields: PropTypes.objectOf(PropTypes.func).isRequired,
            definitions: PropTypes.object.isRequired,
            formContext: PropTypes.shape({
                expanded: PropTypes.bool,
                expandedCallback: PropTypes.func,
                onSubmit: PropTypes.func,
                locale: PropTypes.string,
                params: PropTypes.shape({
                    path: PropTypes.string.isRequired,
                    resource: PropTypes.string.isRequired,
                    action: PropTypes.oneOf(["list","new","view","edit","delete"]).isRequired,
                    id: PropTypes.string,
                    query: PropTypes.object,
                    parentPath: PropTypes.string,
                    parentResource: PropTypes.string,
                    parentAction: PropTypes.oneOf(["list","new","view","edit","delete"]),
                    parentId: PropTypes.string,
                    parentField: PropTypes.string
                })
            }).isRequired,
        }),
    };

    static defaultProps = {
        uiSchema: {},
        formData: {},
        errorSchema: {},
        idSchema: {},
        required: false,
        disabled: false,
        readonly: false,
        autofocus: false
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    isRequired(name) {
        const schema = this.props.schema;
        return (
            Array.isArray(schema.required) && schema.required.indexOf(name) !== -1
        );
    }

    onPropertyChange(name) {
        return (value, options) => {
            const newFormData = { ...this.props.formData, [name]: value };
            this.props.onChange(newFormData, options);
        };
    }

    getChildFields() {
        const {
            uiSchema,
            formData,
            errorSchema,
            idSchema,
            name,
            required,
            disabled,
            readonly,
            onBlur,
            registry = getDefaultRegistry(),
        } = this.props;
        const {definitions, fields} = registry;
        const {SchemaField} = fields;
        const schema = retrieveSchema(this.props.schema, definitions);
        let orderedProperties;
        try {
            const properties = Object.keys(schema.properties);
            orderedProperties = orderProperties(properties, uiSchema["ui:order"]);
        } catch (err) {
            return (
                <div>
                    <p className="config-error" style={{color: "red"}}>
                        Invalid {name || "root"} object field configuration:
                        <em>{err.message}</em>.
                    </p>
                    <pre>{JSON.stringify(schema)}</pre>
                </div>
            );
        }
        return orderedProperties.map((name, index) => {
            return (
                <SchemaField
                    key={index}
                    name={name}
                    required={this.isRequired(name)}
                    schema={schema.properties[name]}
                    uiSchema={uiSchema[name]}
                    errorSchema={errorSchema[name]}
                    idSchema={idSchema[name]}
                    formData={formData[name]}
                    onChange={this.onPropertyChange(name)}
                    onBlur={onBlur}
                    registry={registry}
                    disabled={disabled}
                    readonly={readonly}
                />
            );
        });
    }

    renderSimpleField() {
        const {
            schema,
            name,
            uiSchema,
            idSchema,
            formData,
            required,
            disabled,
            readonly,
            autofocus,
            onChange,
            onBlur,
            onFocus,
            registry = getDefaultRegistry(),
        } = this.props;
        const { title, format } = schema;
        const { widgets, formContext } = registry;
        const enumOptions = isSelect(schema) && optionsList(schema);

        const { widget, placeholder = "", ...options } = getUiOptions(uiSchema);
        const Widget = getWidget(schema, widget, widgets);

        return (
            <Widget
                options={{ ...options, enumOptions }}
                schema={schema}
                id={idSchema && idSchema.$id}
                label={title === undefined ? name : title}
                value={formData}
                onChange={onChange}
                onBlur={onBlur}
                onFocus={onFocus}
                required={required}
                disabled={disabled}
                readonly={readonly}
                formContext={formContext}
                autofocus={autofocus}
                registry={registry}
                placeholder={placeholder}
            />
        );
    }

    render() {
        if (this.props.uiSchema && this.props.uiSchema["ui:widget"]) return this.renderSimpleField();
        let childFields = this.getChildFields();
        return (
            <div>
                {childFields}
            </div>
        );
    }
}

export default ObjectField;
